export default {
    wrapper: null,
    init: function () {
        this.wrapper = document.querySelector('.glossary-substance')
        if (this.wrapper) {
            const glossaryLinks = this.wrapper.querySelectorAll(
                '.glossary-index a'
            )

            Array.from(glossaryLinks).forEach((el) => {
                el.addEventListener('click', (ev) => {
                    this.selectFromIndex(ev.target.dataset.letter)
                    ev.preventDefault()
                })
            })
            if (document.getElementById('substanceName')) {
                this.markActiveLetter()
            }
            this.selectFromIndex('a')
        }
    },
    selectFromIndex: function (letter) {
        const glossaryIndex = document.querySelector('.glossary-index')
        glossaryIndex.querySelector('a.active').classList.remove('active')
        glossaryIndex
            .querySelector('[data-letter="' + letter + '"]')
            .classList.add('active')
        this.filterByLetter(letter)
    },
    filterByLetter: function (letter) {
        const glossaryResultsElements = this.wrapper.querySelectorAll(
            '.glossary-results li'
        )
        Array.from(glossaryResultsElements).forEach((el) => {
            el.classList.add('invisible')
            const elLetter = el.querySelector('a').dataset.letter.toLowerCase()
            if (elLetter === letter) {
                el.classList.remove('invisible')
            }
        })
    },
    markActiveLetter: function () {
        const substanceName = document.getElementById('substanceName')
        const letter = substanceName.dataset.letter.toLowerCase()
        this.selectFromIndex(letter)
    }
}
